module.exports = __webpack_public_path__ + "src/client/screens/Sweepstakes/img/mileiq-taxfyle.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/screens/Sweepstakes/img/mileiq-taxfyle.png
// module id = 1227
// module chunks = 0